export default __webpack_public_path__ + "static/media/080_finish_good.last.d7e1d343.webp";